import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Header } from './header.component';
import { Sidebar } from './sidebar.component';
import { ToastComponent } from '../components/toast/toast.component';
import { SessionPopup } from '../components/session-popup/session-popup.component';
import { EditAccountComponent } from '../components/edit-account/edit-account.component';
import { QuickStartGuideDrawerComponent } from '../components/quick-start-guide-drawer/quick-start-guide-drawer.component';
import { AuthService } from '../core/services/auth.service';

@Component({
  selector: 'app-layout',
  imports: [Header, Sidebar, RouterOutlet, ToastComponent, SessionPopup, EditAccountComponent, QuickStartGuideDrawerComponent],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
})
export class Layout {
  auth = inject(AuthService);
  readonly quickStartOpen = signal(false);
  /** Mirrors the guide panel's pending count — drives the header rocket dot. */
  readonly quickStartPending = signal(false);
  readonly sidebarCollapsed = signal(false);

  toggleQuickStart(): void {
    this.quickStartOpen.update((v) => !v);
  }

  closeQuickStart(): void {
    this.quickStartOpen.set(false);
  }

  toggleSidebar(): void {
    this.sidebarCollapsed.update((v) => !v);
  }
}
